import { ADD_USER_REQUEST, ADD_USER, UPDATE_USER, UPDATE_USER_REQUEST, DELETE_USER, SEARCH_USER_TABLE, GO_TO_PAGE_USER_TABLE, SET_PAGE_SIZE_USER_TABLE, SORT_USER_TABLE, SELECT_USER_CUSTOM_FIELD, UN_SELECT_USER_CUSTOM_FIELD, ADD_USER_CUSTOM_FIELD, DELETE_USER_CUSTOM_FIELD, UPDATE_USER_CUSTOM_FIELD, SELECT_USER_CUSTOM_FIELD_OPTION, UN_SELECT_USER_CUSTOM_FIELD_OPTION, RE_ORDER_USER_CUSTOM_FIELD_OPTION, ADD_USER_CUSTOM_FIELD_OPTION, DELETE_USER_CUSTOM_FIELD_OPTION, UPDATE_USER_CUSTOM_FIELD_OPTION, IUpdateableUserData, UPDATE_USER_WORKFLOWS, UPDATE_USER_CUSTOM_FIELD_START_PIECE, SET_ISOLATED_USER_CUSTOM_FIELD_PIECE, REMOVE_ISOLATED_USER_CUSTOM_FIELD_PIECE, REGISTER_USER_CUSTOM_FIELD_VARIABLE, UPDATE_USER_CUSTOM_FIELD_DATA, AddUserRequestAction, AddUserAction, UpdateUserRequestAction, UpdateUserAction, DeleteUserAction, UpdateUserWorkflowAction, UpdateUserCustomFieldDataAction, SearchUserTableAction, GoToPageUserTableAction, SetPageSizeUserTableAction, SortUserTableAction, SelectUserCustomFieldAction, UnSelectUserCustomFieldAction, AddUserCustomFieldAction, DeleteUserCustomFieldAction, UpdateUserCustomFieldAction, UpdateUserCustomFieldStartPieceAction, SetIsolatedUserCustomFieldPieceAction, RemoveIsolatedUserCustomFieldPieceAction, RegisterUserCustomFieldVariableAction, SelectUserCustomFieldOptionAction, UnSelectUserCustomFieldOptionAction, ReOrderUserCustomFieldOptionAction, AddUserCustomFieldOptionAction, DeleteUserCustomFieldOptionAction, UpdateUserCustomFieldOptionAction, FilterUserTableAction, FILTER_USER_TABLE, UnArchiveUserAction, UN_ARCHIVE_USER, InstantiateUserCustomFieldAction, INSTANTIATE_USER_CUSTOM_FIELD, INSTANTIATE_USER_CUSTOM_FIELD_OPTION, InstantiateUserCustomFieldOptionAction, SetIsFilteringForUserTableAction, SET_IS_FILTERING_FOR_USER_TABLE, SET_IS_SHOWING_ADD_FORM_FOR_USERS, SetIsShowingAddFormForUsersAction, SetIsShowingCSVFormForUsersAction, SetIsShowingFilterFormForUsersAction, SetIsShowingModifyFormForUsersAction, SET_IS_SHOWING_CSV_FORM_FOR_USERS, SET_IS_SHOWING_FILTER_FORM_FOR_USERS, SET_IS_SHOWING_MODIFY_FORM_FOR_USERS, BulkUpdateUserComputedFieldDataAction, BULK_UPDATE_USER_COMPUTED_FIELD_DATA, ComputedFieldUpdatePayloadForUser, RecomputeAllUsersAction, RECOMPUTE_ALL_USERS, UpdateUserComputedFieldDataAction, UPDATE_USER_COMPUTED_FIELD_DATA, BULK_RECALCULATE_COMPUTED_FIELDS_FOR_USER, ChangeDeltaForUserComputedFields, RecalculateComputedFieldsForUserAction, RECALCULATE_COMPUTED_FIELDS_FOR_USER } from './types';
import { INewCustomFieldData, IUpdateableCustomFieldData, INewFieldChoiceData, IUpdateableFieldChoiceData, CustomFieldDataHolder, CustomField, FieldChoice } from '../custom-fields/types';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { PiecePositionState, SearchIndex } from '../../helpers/common-types';

export function addUserRequest(payload: IUpdateableUserData): AddUserRequestAction {
    const now = moment.utc().format();

    return {
        type: ADD_USER_REQUEST,
        payload: {
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            lastUpdatedCustomFieldTime: now,
            lastUpdateTimeForFields: {},
            workflows: {},
        },
    }
}

export function addUser(payload: IUpdateableUserData): AddUserAction {
    const now = moment.utc().format();

    return {
        type: ADD_USER,
        payload: {
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            lastUpdatedCustomFieldTime: now,
            lastUpdateTimeForFields: {},
            workflows: {},
        },
        currentTime: now,
    }
}

export function updateUserRequest(payload: IUpdateableUserData): UpdateUserRequestAction {
    return {
        type: UPDATE_USER_REQUEST,
        payload,
    }
}

export function updateUser(payload: IUpdateableUserData): UpdateUserAction {
    return {
        type: UPDATE_USER,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function deleteUser(id: string): DeleteUserAction {
    return {
        type: DELETE_USER,
        id,
        currentTime: moment.utc().format(),
    }
}

export function unArchiveUser(id: string): UnArchiveUserAction {
    return {
        type: UN_ARCHIVE_USER,
        id,
        currentTime: moment.utc().format(),
    }
}



export function updateUserWorkflows(userId: string, workflowTypeId: string, workflowId: string): UpdateUserWorkflowAction {
    return {
        type: UPDATE_USER_WORKFLOWS,
        userId,
        workflowTypeId,
        workflowId,
    }
}

export function updateUserCustomFieldData(workflowId: string, userId: string, customFieldData: CustomFieldDataHolder): UpdateUserCustomFieldDataAction {
    return {
        type: UPDATE_USER_CUSTOM_FIELD_DATA,
        workflowId,
        userId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function updateUserComputedFieldData(userId: string, customFieldData: CustomFieldDataHolder): UpdateUserComputedFieldDataAction {
    return {
        type: UPDATE_USER_COMPUTED_FIELD_DATA,
        userId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function bulkUpdateUserComputedFieldData(payload: Array<ComputedFieldUpdatePayloadForUser>): BulkUpdateUserComputedFieldDataAction {
    return {
        type: BULK_UPDATE_USER_COMPUTED_FIELD_DATA,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function recomputeAllUsers(): RecomputeAllUsersAction {
    return {
        type: RECOMPUTE_ALL_USERS,
    };
}


export function searchUserTable(searchTerm: string): SearchUserTableAction {
    return {
        type: SEARCH_USER_TABLE,
        searchTerm,
    }
}

export function filterUserTable(projects: Array<string>, levels: Array<string>, roles: Array<string>, locations: Array<string>, unsynced: boolean, areLowerLevelsIncluded: boolean, archived: boolean, customFields: { [customFieldId: string]: Array<string> }): FilterUserTableAction {
    return {
        type: FILTER_USER_TABLE,
        projects,
        levels,
        roles,
        locations,
        unsynced,
        areLowerLevelsIncluded,
        archived,
        customFields,
    }
}

export function setIsFilteringForUserTable(isFiltering: boolean): SetIsFilteringForUserTableAction {
    return {
        type: SET_IS_FILTERING_FOR_USER_TABLE,
        isFiltering,
    };
}

export function goToPageUserTable(pageNumber: number): GoToPageUserTableAction {
    return {
        type: GO_TO_PAGE_USER_TABLE,
        pageNumber,
    }
}

export function setPageSizeUserTable(pageSize: number): SetPageSizeUserTableAction {
    return {
        type: SET_PAGE_SIZE_USER_TABLE,
        pageSize,
    }
}

export function sortUserTable(column: string, order: 'ASC' | 'DESC'): SortUserTableAction {
    return {
        type: SORT_USER_TABLE,
        column,
        order,
    }
}

export function selectUserCustomField(id: string): SelectUserCustomFieldAction {
    return {
        type: SELECT_USER_CUSTOM_FIELD,
        id,
    }
}

export function unSelectUserCustomField(): UnSelectUserCustomFieldAction {
    return {
        type: UN_SELECT_USER_CUSTOM_FIELD,
    }
}

export function addUserCustomField(payload: INewCustomFieldData): AddUserCustomFieldAction {
    const now = moment.utc().format();

    return {
        type: ADD_USER_CUSTOM_FIELD,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        currentTime: now,
    }
}

export function instantiateUserCustomField(payload: CustomField): InstantiateUserCustomFieldAction {
    const now = moment.utc().format();

    return {
        type: INSTANTIATE_USER_CUSTOM_FIELD,
        payload,
        currentTime: now,
    }
}

export function deleteUserCustomField(id: string): DeleteUserCustomFieldAction {
    return {
        type: DELETE_USER_CUSTOM_FIELD,
        id,
        currentTime: moment.utc().format(),
    }
}

export function updateUserCustomField(payload: IUpdateableCustomFieldData): UpdateUserCustomFieldAction {
    return {
        type: UPDATE_USER_CUSTOM_FIELD,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function updateUserCustomFieldStartPiece(payload: PiecePositionState, customFieldId: string): UpdateUserCustomFieldStartPieceAction {
    return {
        type: UPDATE_USER_CUSTOM_FIELD_START_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function setIsolatedUserCustomFieldPiece(payload: PiecePositionState, customFieldId: string): SetIsolatedUserCustomFieldPieceAction {
    return {
        type: SET_ISOLATED_USER_CUSTOM_FIELD_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function removeIsolatedUserCustomFieldPiece(pieceId: string, customFieldId: string): RemoveIsolatedUserCustomFieldPieceAction {
    return {
        type: REMOVE_ISOLATED_USER_CUSTOM_FIELD_PIECE,
        pieceId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function registerUserCustomFieldVariable(variableId: string, customFieldId: string): RegisterUserCustomFieldVariableAction {
    return {
        type: REGISTER_USER_CUSTOM_FIELD_VARIABLE,
        variableId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function setIsShowingAddFormForUsers(showValue: boolean): SetIsShowingAddFormForUsersAction {
    return {
        type: SET_IS_SHOWING_ADD_FORM_FOR_USERS,
        showValue,
    }
}

export function setIsShowingModifyFormForUsers(showValue: boolean): SetIsShowingModifyFormForUsersAction {
    return {
        type: SET_IS_SHOWING_MODIFY_FORM_FOR_USERS,
        showValue,
    }
}

export function setIsShowingFilterFormForUsers(showValue: boolean): SetIsShowingFilterFormForUsersAction {
    return {
        type: SET_IS_SHOWING_FILTER_FORM_FOR_USERS,
        showValue,
    }
}

export function setIsShowingCSVFormForUsers(showValue: boolean): SetIsShowingCSVFormForUsersAction {
    return {
        type: SET_IS_SHOWING_CSV_FORM_FOR_USERS,
        showValue,
    }
}


export function selectUserCustomFieldOption(id: string): SelectUserCustomFieldOptionAction {
    return {
        type: SELECT_USER_CUSTOM_FIELD_OPTION,
        id,
    }
}

export function unSelectUserCustomFieldOption(): UnSelectUserCustomFieldOptionAction {
    return {
        type: UN_SELECT_USER_CUSTOM_FIELD_OPTION,
    }
}

export function reOrderUserCustomFieldOption(sourceIndex: number, destinationIndex: number, parentId: string): ReOrderUserCustomFieldOptionAction {
    return {
        type: RE_ORDER_USER_CUSTOM_FIELD_OPTION,
        sourceIndex,
        destinationIndex,
        parentId,
    }
}

export function addUserCustomFieldOption(payload: INewFieldChoiceData, parentId: string): AddUserCustomFieldOptionAction {
    const now = moment.utc().format();

    return {
        type: ADD_USER_CUSTOM_FIELD_OPTION,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        parentId,
        currentTime: now,
    }
}

export function instantiateUserCustomFieldOption(payload: FieldChoice, parentId: string): InstantiateUserCustomFieldOptionAction {
    return {
        type: INSTANTIATE_USER_CUSTOM_FIELD_OPTION,
        payload,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function deleteUserCustomFieldOption(id: string, parentId: string): DeleteUserCustomFieldOptionAction {
    return {
        type: DELETE_USER_CUSTOM_FIELD_OPTION,
        id,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function updateUserCustomFieldOption(payload: IUpdateableFieldChoiceData): UpdateUserCustomFieldOptionAction {
    return {
        type: UPDATE_USER_CUSTOM_FIELD_OPTION,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function recalculateComputedFieldsForUser(
    userId: string,
    userChanged: boolean,
    locationsChanged: boolean,
    workflowTypesChanged: Array<string>,
): RecalculateComputedFieldsForUserAction {
    return {
        type: RECALCULATE_COMPUTED_FIELDS_FOR_USER,
        userId,
        userChanged,
        locationsChanged,
        workflowTypesChanged,
    }
};

export function bulkRecalculateComputedFieldsForUser(payload: Array<ChangeDeltaForUserComputedFields>) {
    return {
        type: BULK_RECALCULATE_COMPUTED_FIELDS_FOR_USER,
        payload,
    }
}